import { useState, useEffect, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useToast } from '../../../shared/toastMessages/toastProvider';

import {
    Typography,
    Box,
    Stack,
} from '@mui/material';

import TableComponent from "../../../shared/table/table";
import getApiData from '../../../../hooks/apiRequests/getRequest';
import postApiData from '../../../../hooks/apiRequests/postsRequest';
import ModalComponent from '../../../shared/modal/modal';
import AddUser from './addUser/addUser';
import { normalizePageParam } from '../../../../hooks/pagination';

import {theme} from '../../../../configs/theme';
import css from '../../../../styles/portal/main.module.css';

const ManageUsers = () =>{
    const [searchParams, setSearchParams] = useSearchParams();
    const [open, setOpen] = useState(false);
    const [data, setData] = useState();
    const [progress, setProgress] = useState(false);
    const navigate = useNavigate();
    const { showToast } = useToast();
    const query = searchParams.get('query') || '';
    const page = normalizePageParam(searchParams.get('page'));

    const fetchUsers = useCallback(async () => {
      setProgress(true);
      try {
        const response = await getApiData(`/User/List?Search_filter=${encodeURIComponent(query)}&page_number=${page}`);
        if (!response?.data) {
          throw new Error('Empty users list response');
        }
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        showToast("Failed to load data. Redirecting to login...", "error");
      } finally {
        setProgress(false);
      }
    }, [query, page, showToast]);

    useEffect(() => {
        fetchUsers();
    }, [fetchUsers]);

    const addUser = async (body) => {
        try {
            const response = await postApiData("/Create/User", body);
            if (response?.error || !response?.data) {
                showToast("Failed to Create User", "error");
                return;
            }
            handleOpen();
            showToast("Requested The New User", "success");
            await fetchUsers();
        } catch (error) {
            console.error(`Error processing Add request:`, error);
            showToast("Failed to load data. Redirecting to login...", "error");
        }
    };

    const newpage = async (nextPage, search) => {
        setSearchParams({
            query: search || "",
            page: normalizePageParam(nextPage),
        });
    };

    const handleOpen = () =>{
        setOpen(!open)
    };

    const handleNav = (id) =>{
        localStorage.setItem("lastUserListUrl", window.location.pathname + window.location.search);

        navigate(`/Portal/Users/Edit/${id}`);
    };

    return(
        <Box sx={{ px: { xs: 1, md: 2 }, pb: 3 }}>
          <Stack spacing={0.5} sx={{ py: 2 }}>
            <Typography variant="h5" sx={{ fontWeight: 700, color: 'black' }}>
              Manage Users
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Browse and search users, then open a profile to edit details or account settings.
            </Typography>
          </Stack>

          <div className={css.container}>
              <TableComponent
                  apiData={data}
                  progress={progress}
                  noResults={!progress && Array.isArray(data?.data) && data.data.length === 0} 
                  columnNames={{
                      id: "Id",
                      name: "Name",
                      email:"Email",
                      job_role:"Job Role",
                      locked: "Locked",
                      icon: "Icon",
                      time_created: "Time Created",
                  }}
                  hiddenColumns={["failed_attempts"]}
                  handleAdd={handleOpen}
                  handleOpen={handleNav}
                  theme={theme}
                  newpage={newpage}
                  mailingTable={false}
                  query={query}
                  pageNumber={page}
              />
          </div>
          <ModalComponent
              title={"Add New User"}
              subtitle="Create a new portal user account."
              open={open}
              handleOpen={handleOpen}
              theme={theme}
          >
              <AddUser addUser={addUser} handleOpen={handleOpen}/>
          </ModalComponent>
        </Box>
    );
};

export default ManageUsers;